module.exports = __webpack_public_path__ + "img/profitable-img-2.73c8b43f.png";